/* 路由集合 */

export const qywxRouters = [
  {
    path: '/qywx/zhenti',
    name: 'qywx_zhenti',
    hidden: true,
    component: () => import('@/views/qywx/zhenti'),
    meta: {
      title: '真题收集',
      icon: '',
    },
  },
  {
    path: '/qywx/jianzhi',
    name: 'qywx_jianzhi',
    hidden: true,
    component: () => import('@/views/qywx/jianzhi'),
    meta: {
      title: '兼职信息',
      icon: '',
    },
  },
  {
    path: '/qywx/basic',
    name: 'qywx_basic',
    hidden: true,
    component: () => import('@/views/qywx/basic'),
    meta: {
      title: '基础信息',
      icon: '',
    },
  },
]
